export default {
  name: 'TableBtns',
  components: {
    RenderDom: {
      functional: true,
      // 函数式组件 - 无 data 和 this 上下文 => better render
      props: {
        render: Function
      },
      /**
         * @param {Function} createElement - 原生创建dom元素的方法， 弃用，推荐使用 jsx
         * @param {Object} ctx - 渲染的节点的this对象
         * @argument 传递参数 row index
         */
      render(createElement, ctx) {
        return ctx.props.render();
      }
    }
  },
  props: {
    leftText: String,
    btnConfig: Array
    // {
    //     code:2,//1左侧，2右侧
    //     name:"查询", 按钮名字
    //     type:'primary', 类型
    //     handleClick:(e)=>{ click事件
    //       console.log("#####",e)
    //     }
    // },
  },
  data() {
    return {};
  },
  computed: {
    btnLeft() {
      const btnList = this.$store?.state?.permission?.btnList || [];
      return this.btnConfig && this.btnConfig.length > 0 ? this.btnConfig.filter(el => el.code == 1).map(its => {
        // 优先判断是否有权限，无权限，则不展示
        if (!this.hasPermission(btnList, its.permissionValue)) {
          its.isHide = false;
        } else {
          its.isHide = typeof its.isHide === 'function' ? its.isHide() : its.isHide;
        }
        return its;
      }) : [];
    },
    btnRight() {
      const btnList = this.$store?.state?.permission?.btnList || [];
      return this.btnConfig && this.btnConfig.length > 0 ? this.btnConfig.filter(el => el.code == 2).map(its => {
        const item = {
          ...its
        };
        // 优先判断是否有权限，无权限，则不展示
        if (!this.hasPermission(btnList, item.permissionValue)) {
          item.isHide = false;
        } else {
          item.isHide = typeof item.isHide === 'function' ? item.isHide() : item.isHide;
        }
        return item;
      }).filter(item => !item.isHide) : [];
    }
  },
  watch: {
    leftText() {
      console.log(this.leftText);
    }
  },
  mounted() {},
  methods: {
    hasPermission(btnList, pvalue) {
      // 当前没菜单数据，认为无权限
      if (!btnList || !btnList.length) {
        return false;
      }
      // 操作按钮未配置权限，则认为有权限
      if (!pvalue) {
        return true;
      }
      let has = false;
      for (let i = 0; i < btnList.length; i += 1) {
        if (pvalue === btnList[i].permissionValue) {
          has = true;
          break;
        }
      }
      return has;
    }
  }
};